var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-button',{staticStyle:{"margin-right":"10px"},attrs:{"size":"mini","type":"primary"},on:{"click":_vm.handleEdit}},[_vm._v(" 编辑 ")]),_c('el-popconfirm',{attrs:{"title":"确定删除吗？"},on:{"confirm":_vm.handleDelete}},[_c('el-button',{attrs:{"slot":"reference","size":"mini","type":"danger"},slot:"reference"},[_vm._v("删除")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }